var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inbox-body"},[_c('app-messages',{attrs:{"messages":_vm.trashedMessages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }